/* eslint-disable import/prefer-default-export */

export const getRandomElementFromArray = <T>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

export const rearrangeArray = (inputArray: any, desiredOrder: any): any => {
  return desiredOrder.filter((item: any): any => inputArray.includes(item));
};
